import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownOutlined } from "@ant-design/icons";
const UserPillSkeleton = ()=>/*#__PURE__*/ _jsxs("span", {
        "aria-hidden": true,
        className: "rc-account-v2-hero__user-pill rc-account-v2-hero__user-pill--skeleton",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "rc-account-v2-hero__user-pill-avatar rc-account-v2-hero__user-pill-avatar--skeleton"
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "rc-account-v2-hero__user-pill-text",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "rc-account-v2-hero__user-pill-name-skeleton"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "rc-account-v2-hero__user-pill-email-skeleton"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(DownOutlined, {
                className: "rc-account-v2-hero__user-pill-caret"
            })
        ]
    });
export { UserPillSkeleton };
